/**
 * @return {void}
 */
function form() {
    Form_initAll();
}

form();

/**
 * @param countrySelect {HTMLSelectElement}
 * @return {void}
 */
function When_countrySelectChanges(countrySelect) {
    const country = countrySelect.value;

    const form = countrySelect.closest("form");

    if (form instanceof HTMLFormElement) {
        if (country === "United States") {
            Form_showUSPrivacyPolicy(form);
        } else if (country === "United Kingdom") {
            Form_showUKPrivacyPolicy(form);
        } else {
            Form_showEMEAPrivacyPolicy(form);
        }
    }
}

/**
 * @param countrySelect {HTMLSelectElement}
 * @return {void}
 */
function CountrySelect_init(countrySelect) {
    countrySelect.addEventListener(
        "change",
        ev => When_countrySelectChanges(ev.currentTarget)
    );
}

/**
 * @param form {HTMLFormElement}
 * @return {void}
 */
function Form_init(form) {
    const countrySelect = form.querySelector('[name="Country"]');

    if (countrySelect instanceof HTMLSelectElement) {
        CountrySelect_init(countrySelect);
    }
}

/**
 * @return {void}
 */
function Form_initAll() {
    const forms = document.querySelectorAll("form");
    for (const form of forms) {
        if (form instanceof HTMLFormElement) {
            Form_init(form);
        }
    }
}

/**
 * @param form {HTMLFormElement}
 * @return {void}
 */
function Form_showUSPrivacyPolicy(form) {
    Form_showPrivacyPolicyForRegion(form, "US");
}

/**
 * @param form {HTMLFormElement}
 * @return {void}
 */
function Form_showUKPrivacyPolicy(form) {
    Form_showPrivacyPolicyForRegion(form, "UK");
}

/**
 * @param form {HTMLFormElement}
 * @return {void}
 */
function Form_showEMEAPrivacyPolicy(form) {
    Form_showPrivacyPolicyForRegion(form, "EMEA");
}

/**
 * @param form {HTMLFormElement}
 * @param region {"US" | "UK" | "EMEA"}
 * @return {void}
 */
function Form_showPrivacyPolicyForRegion(form, region) {
    let privacyPolicy = form.querySelector('.marketingConsent__wrap');
    if (!privacyPolicy) {
        privacyPolicy = form.querySelector('[data-component="PrivacyPolicyCheckbox"]');
    }

    if (privacyPolicy instanceof HTMLElement) {
        privacyPolicy.style.display = "";
    }

    const privacyPolicyCheckboxWrap = form.querySelector('[data-component="PrivacyPolicyCheckbox"]');
    if (privacyPolicyCheckboxWrap instanceof HTMLElement) {
        if (region === "US") {
            privacyPolicyCheckboxWrap.style.display = "none";
        } else {
            privacyPolicyCheckboxWrap.style.display = "";
        }
    }

    const privacyPolicyPartnerCheckboxWrap = form.querySelector('[data-component="PrivacyPolicyPartnerCheckbox"]');
    if (privacyPolicyPartnerCheckboxWrap instanceof HTMLElement) {
        if (region === "US" || region === "UK") {
            privacyPolicyPartnerCheckboxWrap.style.display = "none";
        } else {
            privacyPolicyPartnerCheckboxWrap.style.display = "";
        }
    }

    const privacyPolicyPartnerCheckbox = form.querySelector('[name="partnerMarketingOptIn"]');
    if (privacyPolicyPartnerCheckbox instanceof HTMLInputElement) {
        privacyPolicyPartnerCheckbox.checked = false;
    }

    const privacyPolicyCheckbox = form.querySelector('[name="marketingConsent"]');
    if (privacyPolicyCheckbox instanceof HTMLInputElement) {
        privacyPolicyCheckbox.checked = false;
    }

    const privacyPolicyMessage_US = form.querySelector('[data-component="PrivacyPolicyMessage_US"]');
    if (privacyPolicyMessage_US instanceof HTMLElement) {
        if (region === "US") {
            privacyPolicyMessage_US.style.display = "";
        } else {
            privacyPolicyMessage_US.style.display = "none";
        }
    }

    const privacyPolicyMessage_UK = form.querySelector('[data-component="PrivacyPolicyMessage_UK"]');
    if (privacyPolicyMessage_UK instanceof HTMLElement) {
        if (region === "UK") {
            privacyPolicyMessage_UK.style.display = "";
        } else {
            privacyPolicyMessage_UK.style.display = "none";
        }
    }

    const privacyPolicyMessage_EMEA = form.querySelector('[data-component="PrivacyPolicyMessage_EMEA"]');
    if (privacyPolicyMessage_EMEA instanceof HTMLElement) {
        if (region === "US" || region === "UK") {
            privacyPolicyMessage_EMEA.style.display = "none";
        } else {
            privacyPolicyMessage_EMEA.style.display = "";
        }
    }
}
